import { Button, Grid, Typography } from "@mui/material"

import { useDispatch, useSelector } from "react-redux"
import { icons } from 'src/assets'
import { estimateActions } from "src/ducks/actions"
import { ShareEstimateRequest } from "src/ducks/estimate/types"
import { getEstimate } from "src/ducks/selectors"
import { Contact } from "src/ducks/types"
import { ESTIMATE_STATUS, formatTimestamp } from "src/helpers/index"
import useStyles from './styles'

const ContactsListTab = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const estimate = useSelector(getEstimate())
  // const user = useSelector(getUser)

  // const isAgent = [USER_TYPE.BROKER, USER_TYPE.INSPECTOR, USER_TYPE.INSTITUTIONAL].includes(user.clientType)

  const handleShare = (contact: Contact) => {
    dispatch(estimateActions.shareEstimate(contact as Partial<ShareEstimateRequest>, (succ) => {
    }))
  }

  return (
    <Grid container spacing={1} className={classes.container}>
      {estimate?.properties.contacts?.map((contact, index) => {
        // const role = getContactRoleOpt()?.find(contactOption => contactOption?.key === contact?.role)
        return (
          <Grid item container key={index} className={classes.contactListContainer}>
            <Grid item xs={10}>
              <Typography className={classes.title}>{contact?.firstName} {contact?.lastName} </Typography>
              <Typography variant="body2" className={classes.role}>{contact?.email} </Typography>
            </Grid>
            <Grid container item xs={2} className={classes.actions}>
              <Button
                className={classes.buttonShare}
                onClick={() => handleShare(contact)}
                disabled={estimate.status === ESTIMATE_STATUS.APPROVED}
              >
                <icons.Share className={classes.buttonShareIcon} />
              </Button>
              {contact?.insertedOn &&
                <Typography className={classes.small}>Shared on: {formatTimestamp(contact?.insertedOn, 'MMM D, YYYY')}</Typography>
              }
            </Grid>
          </Grid>
        )
      }
      )}
    </Grid >
  )
}

export default ContactsListTab